import styled from 'styled-components'

export const Container = styled.div<{ loadingData: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ loadingData }) => (loadingData ? 'default' : 'pointer')};
  font-family: AzoSans;
`
